/*
 * Single source of truth for HSOC tier identity + ordering in the public app.
 * Shared by the merch cards (hsocPublicCards) and the feature-table columns
 * (feature-table/publicFeatureTableData) so the two surfaces order and gate
 * tiers identically. Only tiers present in a response are rendered, in this
 * order. Mirrors the in-app v2/hsoc/hsocTiers module.
 */
export const HSOC_TIER_ORDER = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
export function isHsocTierName(value) {
  return HSOC_TIER_ORDER.includes(value);
}

/*
 * The tiers present in a productsByTier-shaped map, in HSOC_TIER_ORDER. Typed
 * against a plain string-keyed record so both the card mapper's and the feature
 * table's (differently Pick'd) tier-option maps can pass through.
 */
export function getPresentHsocTierNames(productsByTier) {
  if (!productsByTier) {
    return [];
  }
  return HSOC_TIER_ORDER.filter(tierName => tierName in productsByTier);
}